import React from 'react';
import { observer } from 'src/utils/mobx-react';
import {
    OffersSettingsContainer,
    OffersSettingsContentContainer,
    OffersSettingsContentHeader,
    OffersSettingsContentRow,
    OffersSettingsContentRowContainer,
    OffersSettingsContentRowsContainer,
    OffersSettingsContentRowText,
    OffersSettingsHeader,
    OffersSettingsSubHeader,
} from './OffersSettingsNew.style';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import { Toggle } from 'src/components/toggle/Toggle';
import { OffersContactPreferencesNewState } from './OffersSettingsNew.state';
import { ContactPreferencesNewOptionType } from 'src_server/trpc/types/accountModel/changeAccountContactPreferencesNew';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
interface ContactPreferenceType {
    type: 'email' | 'sms' | 'phone';
    text: string;
}

const ContactPreferences: ContactPreferenceType[] = [
    {
        type: 'email',
        text: 'Email',
    },
    {
        type: 'sms',
        text: 'Text Message (SMS)',
    },
    {
        type: 'phone',
        text: 'Phone Call',
    },
];

interface PropsType {
    state: OffersContactPreferencesNewState;
    contactPreferencesCategories: ContactPreferencesNewOptionType[];
    variant?: 'light' | 'dark';
    haveHeader?: boolean;
    additionalContainer?: boolean;
}

export const OffersSettingsNew = observer(
    'OffersSettingsNew',
    ({
        state,
        contactPreferencesCategories,
        variant = 'dark',
        haveHeader = true,
        additionalContainer = false,
    }: PropsType) => {
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        const configContactPreferences = configState.contactPreferences;

        return (
            <OffersSettingsContainer>
                {haveHeader ? (
                    <>
                        <OffersSettingsHeader data-test='offers-settings-new-header'>
                            <I18n
                                langKey='offers-settings.header'
                                defaultText='Choose how you receive offers'
                            />
                        </OffersSettingsHeader>
                        <OffersSettingsSubHeader data-test='offers-settings-sub-new-header'>
                            <I18n
                                langKey='offers-settings.subheader'
                                defaultText='Stay up to date and receive handpicked promotions, news and insider tips from us.'
                            />
                        </OffersSettingsSubHeader>
                    </>
                ) : null}

                <OffersSettingsContentContainer>
                    {ContactPreferences.filter((contact) => configContactPreferences.includes(contact.type)).map(
                        (contact) => (
                            <OffersSettingsContentRowContainer
                                key={contact.type}
                                data-test='offers-settings-content-row-container'
                            >
                                <OffersSettingsContentHeader>
                                    <I18n
                                        langKey='offers-settings.contact.type'
                                        defaultText='{text}'
                                        params={{
                                            text: contact.text,
                                        }}
                                    />
                                </OffersSettingsContentHeader>
                                <OffersSettingsContentRowsContainer
                                    additionalContainer={additionalContainer}
                                    systemPagesVariant={configState.componentVariants.systemPagesVariant}
                                >
                                    {contactPreferencesCategories.map((option) => (
                                        <OffersSettingsContentRow key={option}>
                                            <OffersSettingsContentRowText>
                                                <I18n
                                                    langKey='offers-settings.contact.type.option'
                                                    defaultText='{text}'
                                                    params={{
                                                        text: option,
                                                    }}
                                                />
                                            </OffersSettingsContentRowText>
                                            <Toggle
                                                toggleActive={(): void => {
                                                    state[contact.type][option].setValue(
                                                        !state[contact.type][option].value
                                                    );
                                                }}
                                                variant={variant}
                                                isActive={state[contact.type][option].value}
                                            />
                                        </OffersSettingsContentRow>
                                    ))}
                                </OffersSettingsContentRowsContainer>
                            </OffersSettingsContentRowContainer>
                        )
                    )}
                </OffersSettingsContentContainer>
            </OffersSettingsContainer>
        );
    }
);
